import { render, staticRenderFns } from "./HomePageHignlighted.vue?vue&type=template&id=272c6ab8&scoped=true&"
import script from "./HomePageHignlighted.vue?vue&type=script&lang=js&"
export * from "./HomePageHignlighted.vue?vue&type=script&lang=js&"
import style0 from "./HomePageHignlighted.vue?vue&type=style&index=0&id=272c6ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272c6ab8",
  null
  
)

export default component.exports